import Vue from "vue";
import Vuex from "vuex";
import api from "../api";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    host:
      process.env.NODE_ENV === "production" ? "" : "https://www.qazlatyn.kz",
    loading: false,
    siteSettings: [],
    showLoading: false,
    showPrompt: {
      status: false,
      type: "error",
      message: null
    },
    currentLanguage: null,
    languageList: [],
    languagePack: {},
    canload: false,
    viewbookCurrent: {},
    navigationList: []
  },
  mutations: {
    showLoading(state, payload) {
      state.showLoading = payload;
    },
    setCurrentLanguage(state, payload) {
      state.currentLanguage = payload;
    },
    setLanguageList(state, payload) {
      state.languageList = payload;
    }
  },
  getters: {
    showLoading: state => state.showLoading,
    getCurrentLanguage: state => state.currentLanguage,
    languageList: state => state.languageList
  },
  actions: {
    setLanguage(context) {
      context.commit("showLoading", true);
      api.getLanguageList(response => {
        context.commit("showLoading", false);
        if (response.status === 200) {
          if (response.body.status === "success") {
            context.commit("setLanguageList", response.body.data);
            context.commit(
              "currentLanguage",
              response.body.data.filter(l => l.isDefault)[0]
            );
          } else {
            context.commit("showError", {
              show: true,
              type: "error",
              message: response.message
            });
          }
        } else {
          context.commit("showError", {
            show: true,
            type: "error",
            message: "Some unhandled error!"
          });
        }
      });
    },
    getCurrentLanguage(context) {
      context.getters("currentLanguage");
    },
    setLanguageList(context) {
      context.commit("languageList");
    },
    getLanguageList(context) {
      context.getters("languageList");
    }
  }
});

export default store;
